import { useImperativeModal } from "ImperativeModalProvider";
import { CertificateDisplayType } from "type/certificateType";
import Icon from "components/Icon";
import { NormalModal } from "~/modals/common/NormalModal";
import SignRequestDoctorButton from "./SignRequestDoctorButton";
import { Box } from "./CertificateDisplay.styled";

type DisplayStatusType = CertificateDisplayType | null | "SELECT_DOCTOR";

interface CertificateDisplayProps {
  displayStatus: DisplayStatusType;
  signRequestDoctorId: null | number;
  setSignRequestDoctorId: (id: number) => void;
}

const getGuideText = (certificateStatus: CertificateDisplayType) => {
  switch (certificateStatus) {
    case "AUTO":
      return (
        <Box className="contents">
          로그인 계정에 등록된 인증서로 자동 전자서명 처리되고 있습니다.
          <br />
          {`[‘PC 우노CRM>전자서명>전자서명 설정’옵션 변경가능]`}
        </Box>
      );
    case "MANUAL":
      return (
        <Box className="contents">
          로그인 계정에 등록된 인증서로 인증서 비밀번호를 입력 후 전자서명 처리
          할 수 있습니다.
          <br />
          {`[‘PC 우노CRM>전자서명>전자서명 설정’옵션 변경가능]`}
        </Box>
      );
    case "NOT_USED":
      return (
        <Box className="contents">
          로그인 계정에 등록된 전자서명 인증서가 없습니다.
          <br />
          {`[‘PC 우노CRM>전자서명>전자서명 설정>전자서명 안내’ 참고]`}
        </Box>
      );
    case "EXPIRE":
      return (
        <Box className="contents">
          로그인 계정에 등록된 전자서명 인증서가 만료되었습니다.
          <br />
          {`[‘PC 우노CRM>전자서명>전자서명 설정>전자서명 안내’ 인증서 발급 및 등록 필요]`}
        </Box>
      );
  }
};

const getTextColorName = (displayStatus: DisplayStatusType) => {
  switch (displayStatus) {
    case "EXPIRE":
      return "red";
    case "NOT_USED":
      return "grey";
    case "AUTO":
    case "MANUAL":
    default:
      return "default";
  }
};

const CertificateDisplay = ({
  displayStatus,
  signRequestDoctorId,
  setSignRequestDoctorId,
}: CertificateDisplayProps) => {
  const imperativeModal = useImperativeModal();

  const handleOpenCertificateGuidePopup = async () => {
    if (displayStatus && displayStatus !== "SELECT_DOCTOR") {
      await imperativeModal.open((close) => (
        <NormalModal
          className="not-border-bottom"
          title="펜차트 전자서명 안내"
          open={true}
          onClose={close}
        >
          {getGuideText(displayStatus)}
        </NormalModal>
      ));
    }
  };

  return (
    <Box className="certificate-display-wrapper">
      {displayStatus === "SELECT_DOCTOR" ? (
        <SignRequestDoctorButton
          signRequestDoctorId={signRequestDoctorId}
          setSignRequestDoctorId={setSignRequestDoctorId}
        />
      ) : (
        <Box
          className={`certificate-text ${getTextColorName(displayStatus)}`}
          onClick={handleOpenCertificateGuidePopup}
        >
          {displayStatus === "AUTO" && <span>자동 전자서명</span>}
          {displayStatus === "MANUAL" && <span>수동 전자서명</span>}
          {displayStatus === "EXPIRE" && <span>전자서명 인증서 만료</span>}
          {displayStatus === "NOT_USED" && <span>전자서명 미사용</span>}
          {displayStatus && <Icon variant="questionMark" />}
        </Box>
      )}
    </Box>
  );
};

export default CertificateDisplay;
